export const useGlobalToast = () => {
  const globalToast = inject('globalToast') as { open: boolean; message: string }

  const open = (message: string) => {
    if (message) globalToast.message = message || ''
    globalToast.open = true
  }

  const close = () => {
    globalToast.open = false
  }

  return {
    open,
    close
  }
}
